// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListCardStyles } from "@keller/Overrides/Components/WishListCard";
import { css } from "styled-components";

wishListCardStyles.spinner = {
    size: 12,
    css: css`
        margin-right: 8px;
    `,
};

wishListCardStyles.basicInfoGridItem = {
    ...wishListCardStyles.basicInfoGridItem,
    css: css`
        align-items: flex-start;
    `,
};

wishListCardStyles.basicIconGridContainer = {
    ...wishListCardStyles.basicIconGridContainer,
    offsetCss: css`
        flex-direction: column;
        padding-top: 3px;
    `,
};

wishListCardStyles.detailIconGridItem = {
    width: 12,
};

wishListCardStyles.tagTooltip = {
    ...wishListCardStyles.tagTooltip,
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 0px;
            margin-right: 0px;
        `,
    },
    iconProps: {
        ...wishListCardStyles.tagTooltip?.iconProps,
        css: css`
            margin: 8px 0;
        `,
    },
};
